const initialState = {
  loading: false,
  user: null,
  user_error: null,
  login_error:null,
  userPermission: null,
  userActivity: null,
  error: "",
  putUserResponse: null,
  putUserResponseError: null,
  idpPermissions: null,
  userFeedList: [],
  userFeedListLoading: null,
  userKeywords: [],
  userFeedBack: null,
  postUserFeedBack: null,
  errorPostUserFeedBack: null,
  loadMoreloading: null,
  commonSignInCheck: null,
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_USER_IN_STATE":
      return {
        ...state,
        loading: false,
        user: action.payload,
      };

    case "SET_PERMISSIONS_IN_STATE":
      return {
        ...state,
        loading: false,
        userPermission: action.payload,
      };
    case "TOKEN_ERROR":
      return {
        ...state,
        loading: false,
        user: null,
        user_error: action.payload,
      };
      case "LOGIN_ERROR":
      return {
        ...state,
        loading: false,
        user: null,
        login_error: action.payload,
      };
    case "LOGOUT_USER":
      return {
        loading: false,
        user: null,
      };
    case "GET_USER_ACTIVITY_SUCCESS":
      return {
        ...state,
        userActivity: action.payload,
        loading: false,
      };
    case "GET_USER_ACTIVITY_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "POST_USER_ACTIVITY_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "POST_USER_ACTIVITY_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "PUT_USER_DETAIL_SUCCESS":
      return {
        ...state,
        putUserResponse: action.payload,
      };
    case "PUT_USER_DETAIL_FAILURE":
      return {
        ...state,
        putUserResponseError: action.payload,
      };
    case "GET_IDP_PERMISSION_SUCCESS":
      return {
        ...state,
        idpPermissions: action.payload,
        loading: false,
      };
    case "GET_IDP_PERMISSION_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_PUT_USER_DETAILS_RESPONSE":
      return {
        ...state,
        putUserResponse: null,
        putUserResponseError: null,
      };
    case "GET_USER_FEED_REQUEST":
      return {
        ...state,
        userFeedListLoading: true,
      };
    case "GET_USER_FEED_SUCCESS":
      return {
        ...state,
        userFeedList: action.payload,
        userFeedListLoading: false,
      };
    case "GET_USER_FEED_FAILURE":
      return {
        ...state,
        userFeedListLoading: false,
        error: action.payload,
      };
    case "GET_USER_KEYWORD_SUCCESS":
      return {
        ...state,
        userKeywords: action.payload,
        loading: false,
      };
    case "GET_USER_KEYWORD_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "POST_USER_KEYWORD_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "POST_USER_KEYWORD_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_USER_FEEDBACK_SUCCESS":
      return {
        ...state,
        userFeedBack: action.payload,
        loading: false,
      };
    case "GET_USER_FEEDBACK_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "POST_USER_FEEDBACK_SUCCESS":
      return {
        ...state,
        postUserFeedBack: action.payload,
        loading: false,
      };
    case "POST_USER_FEEDBACK_FAILURE":
      return {
        ...state,
        loading: false,
        errorPostUserFeedBack: action.payload,
      };
    case "LOAD_MORE_USER_FEED_REQUEST":
      return {
        ...state,
        loadMoreloading: true,
      };
    case "LOAD_MORE_USER_FEED_SUCCESS":
      let updatedUserFeedList = {};
      updatedUserFeedList = state.userFeedList;
      updatedUserFeedList.data.user_feed.user_feed.push(
        ...action.payload.data.user_feed.user_feed
      );
      updatedUserFeedList.data.user_feed.has_next =
        action.payload.data.user_feed.has_next;
      updatedUserFeedList.data.user_feed.has_prev =
        action.payload.data.user_feed.has_prev;
      updatedUserFeedList.data.user_feed.status =
        action.payload.data.user_feed.status;
      return {
        ...state,
        loadMoreloading: false,
        userFeedList: updatedUserFeedList,
      };
    case "LOAD_MORE_USER_FEED_FAILURE":
      return {
        ...state,
        loadMoreloading: false,
        error: action.payload,
      };
    case "GET_USER_FEED_GENERATE_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "GET_USER_FEED_GENERATE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "POST_COMMON_SIGNIN_CHECK_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "POST_COMMON_SIGNIN_CHECK_FAILURE":
      return {
        ...state,
        loading: false,
        commonSignInCheck: action.payload,
      };
    case "POST_COMMON_SIGNIN_CHECK_SUCCESS":
      return {
        ...state,
        loading: false,
        commonSignInCheck: action.payload,
      };
    case "POST_VALIDATE_FIELDS_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "POST_VALIDATE_FIELDS_FAILURE":
      return {
        ...state,
        loading: false,
        validateFields: action.payload,
      };
    case "POST_VALIDATE_FIELDS_SUCCESS":
      return {
        ...state,
        loading: false,
        validateFields: action.payload,
      };
    default:
      return state;
  }
};

export default UserReducer;
